import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Path} from '@core/enums';
import {PartnerService} from '@app/partner/services/partner.service';
import {catchError, map, switchMap} from 'rxjs/operators';
import {AuthService} from '@app/+auth/shared/services/auth.service';
import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class PartnerVerifiedGuard implements CanActivate {
  constructor(
    private router: Router,
    private partnerService: PartnerService,
    private  authService: AuthService,
    private toastr: ToastrService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // Check if userInfo exists
    const userInfo = JSON.parse(localStorage.getItem('_user'));

    // If userInfo doesn't exist or user is not a partner, redirect to sign-in page
    if (!userInfo || userInfo.userType !== 'partner') {
      this.router.navigate([`/${Path.SignIn}`],   {
        queryParams: { returnUrl: state.url },
      });
      return false; // Prevent access to the route
    }

    // Check the account active status
    const userId = userInfo._id;
    return this.partnerService.getUserInformationById(userId).pipe(
      switchMap(async response => {
        const isAccountActive = response.body.userInformation.isAccountActive;
        if (isAccountActive === false) {
          // Perform logout process
          await this.authService.logout().toPromise();
          this.authService.logoutLocal();
          // Redirect to sign-in page if account is not active
          this.router.navigate([`/${Path.SignIn}`], {
            queryParams: { returnUrl: state.url },
          });
          this.toastr.error('Please contact support@gabadoo.com for more information ', 'Account Deactivated');
          return false; // Prevent access to the route
        }
        return true; // Allow access to the route
      }),
      catchError(error => {
        // Handle error response
        console.error('An error occurred while fetching user information:', error);
        // Redirect to sign-in page in case of error
        this.router.navigate([`/${Path.SignIn}`], {
          queryParams: { returnUrl: state.url },
        });
        return of(false); // Prevent access to the route
      })
    );
  }

}
